import './App.css';
import Routes from './routes';

function App() {
  return (
    <div className='h-screen'>
      <Routes />
    </div>
  );
}

export default App;
